import { render, staticRenderFns } from "./HSChaperoneReg.vue?vue&type=template&id=b94ec156"
import script from "./HSChaperoneReg.vue?vue&type=script&lang=js"
export * from "./HSChaperoneReg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports